module.exports = __webpack_public_path__ + "static/media/15_after.714ddd15.jpg";